import { createContext, useState, useRef, useCallback, useEffect } from 'react';
import { getWithToken } from '../API/Api';

export const ProgressContext = createContext();

export const ProgressProvider = ({ children }) => {
  const [progress, setProgress] = useState(0);
  const [urlStats, setUrlStats] = useState({ success: 0, total: 0, faq_count: null });
  const [isProgressActive, setIsProgressActive] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const intervalRef = useRef(null);

  const stopPolling = useCallback(() => {
    clearInterval(intervalRef.current);
    setIsProgressActive(false);
    setProgress(0);
    localStorage.removeItem('activeTaskId');
  }, []);

  const startPolling = useCallback(
    (token, taskId) => {
      setIsProgressActive(true);
      localStorage.setItem('activeTaskId', taskId);
      intervalRef.current = setInterval(() => {
        getWithToken(`KB_questionsURLAPI/${taskId}`, token)
          .then((res) => {
            if (res.status === 200) {
              const current = res.data.percentange;
              setProgress(current);
              setUrlStats({
                success: res.data.success_url ?? 0,
                total: res.data.total_url ?? 0,
                faq_count: res.data.faq_count ?? null,
                is_faq_generated: res.data?.is_faq_generated,
              });

              if (current >= 100 || res.data.status === 'completed') {
                stopPolling();
                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 30000);
              }
            } else {
              stopPolling();
            }
          })
          .catch(stopPolling);
      }, 3000);
    },
    [stopPolling]
  );

  // 🔹 Auto-resume polling on refresh
  useEffect(() => {
    const savedTaskId = localStorage.getItem('activeTaskId');
    const token = localStorage.getItem('apiToken');
    if (savedTaskId && token && !isProgressActive) {
      startPolling(JSON.parse(token), savedTaskId);
    }
  }, [isProgressActive, startPolling]);

  return <ProgressContext.Provider value={{ progress, urlStats, isProgressActive, startPolling, stopPolling, showPopup, setShowPopup }}>{children}</ProgressContext.Provider>;
};
